import { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { MailCheck, MailX, Loader2 } from 'lucide-react';
import { api, formatApiError } from '@/lib/api';

export default function ConfirmEmail() {
  const { token } = useParams();
  const [state, setState] = useState({ status: 'loading', msg: '' });
  useEffect(() => {
    api.post('/auth/verify-email', { token })
      .then(() => setState({ status: 'ok', msg: '' }))
      .catch(e => setState({ status: 'error', msg: formatApiError(e) }));
  }, [token]);

  return (
    <div className="max-w-lg mx-auto px-6 py-24 text-center" data-testid="confirm-email-page">
      {state.status === 'loading' && <Loader2 size={40} className="mx-auto animate-spin text-chartreuse"/>}
      {state.status === 'ok' && (
        <>
          <MailCheck size={48} className="mx-auto text-chartreuse" strokeWidth={1.4}/>
          <h1 className="mt-5 font-display text-4xl tracking-tight" data-testid="confirm-email-ok">Email confermata</h1>
          <p className="mt-3 text-muted-foreground">Il tuo account è attivo. Se ti ha invitato un amico, il suo invito diventa valido quando pubblichi il primo annuncio o fai una stima Yield AI PRO.</p>
          <div className="mt-8 flex gap-3 justify-center flex-wrap">
            <Link to="/dashboard" className="h-11 px-6 rounded-full bg-chartreuse text-obsidian font-medium inline-flex items-center">Vai alla Dashboard</Link>
            <Link to="/stima-quintali" className="h-11 px-6 rounded-full border border-border inline-flex items-center">Prova Yield AI PRO</Link>
          </div>
        </>
      )}
      {state.status === 'error' && (
        <>
          <MailX size={48} className="mx-auto text-terracotta" strokeWidth={1.4}/>
          <h1 className="mt-5 font-display text-4xl tracking-tight">Link non valido</h1>
          <p className="mt-3 text-muted-foreground" data-testid="confirm-email-error">{state.msg}</p>
          <Link to="/dashboard" className="mt-8 h-11 px-6 rounded-full border border-border inline-flex items-center">Vai alla Dashboard</Link>
        </>
      )}
    </div>
  );
}
